<template>
  <q-item v-if="isMenu" clickable>
    <q-item-section avatar>
      <q-avatar icon="schedule"/>
    </q-item-section>
    <q-item-section>
      <q-item-label>{{ selectedCampaign.name }}</q-item-label>
    </q-item-section>
    <q-menu>
      <q-list>
        <q-item
          v-for="campaign of campaigns" :key="campaign.code"
          clickable
          v-close-popup
          @click="onCampaignClick(campaign)"
        >
          <q-item-section>
            <q-item-label>{{ campaign.name }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-item>
  <span v-else-if="!!isHeader && $q.screen.gt.md">
    <q-btn-dropdown
      flat stack split
      v-if="campaigns && campaigns.length > 1"
      icon="schedule"
      :label="selectedCampaign.name"
      v-model="showDropdownCampaigns"
      @click="clickOptions"
    >
      <q-list>
        <q-item
          v-for="campaign of campaigns" :key="campaign.code"
          clickable
          v-close-popup
          @click="onCampaignClick(campaign)"
        >
          <q-item-section>
            <q-item-label>{{ campaign.name }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
    <q-btn
      v-else-if="selectedCampaign"
      flat stack
      icon="schedule"
      :label="selectedCampaign.name"
      :clickable="false"
    />
  </span>
  <span v-else>
    <q-btn-dropdown
      flat stretch
      v-if="campaigns && campaigns.length > 1"
      :label="selectedCampaign.name"
      v-model="showDropdownCampaigns"
      @click="clickOptions"
    >
      <q-list>
        <q-item
          v-for="campaign of campaigns" :key="campaign.code"
          clickable
          v-close-popup
          @click="onCampaignClick(campaign)"
        >
          <q-item-section>
            <q-item-label>{{ campaign.name }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
    <q-btn
      v-else-if="selectedCampaign"
      flat stretch
      :label="selectedCampaign.name"
      :clickable="false"
    />
  </span>
</template>

<script>
import { ClosePopup, QAvatar, QBtn, QBtnDropdown, QItem, QItemLabel, QItemSection, QList, QMenu } from 'quasar'
import { mapState } from 'vuex'

export default {
  props: ['isHeader', 'isMenu'],
  data () {
    return {
      showDropdownCampaigns: false
    }
  },
  components: {
    QAvatar, QBtn, QBtnDropdown, QItem, QItemLabel, QItemSection, QList, QMenu
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      campaigns: state => state.panorama.campaigns,
      selectedCampaign: state => state.panorama.selectedCampaign
    })
  },
  methods: {
    clickOptions () {
      if (this.isHeader) {
        this.showDropdownCampaigns = !this.showDropdownCampaigns
      }
    },
    onCampaignClick (campaign) {
      this.$store.dispatch('panorama/selectCampaign', campaign)
    }
  }
}
</script>
